import integrityUtilities from '@/utilities/integrityUtilities'

let RoleTypes = {
  Super: 'RMS Super Admin',
  Admin: 'RMS Admin',
  Finance: 'RMS Finance',
  Manager: 'RMS Manager',
  Operations: 'RMS Operations',
  Customer: 'RMS Customer',
  Provider: 'RMS Provider',
}

RoleTypes.ReusabilitySet = [
  RoleTypes.Admin,
  RoleTypes.Finance,
  RoleTypes.Manager,
  RoleTypes.Operations,
]

export default integrityUtilities.deepFreeze(RoleTypes)
